import {message} from "antd";

export function messageSuccess(text, timeout) {
  message.success(text, timeout);
  cleanFirefoxDivs()
}

export function cleanFirefoxDivs() {
  var style = "position: absolute; top: 0px; left: 0px; width: 100%;"

  var modalDiv = document.getElementsByClassName('ant-modal-mask')[0]
  if (typeof modalDiv != 'undefined') {
    modalDiv.parentElement.parentElement.setAttribute("style", style);
  }
  var messageDiv = document.getElementsByClassName('ant-message')[0]
  if (typeof messageDiv != 'undefined') {
    messageDiv.parentElement.setAttribute("style", style);
  }

}

export function calculateMonthlyDiscountFromStripeCoupon(coupon, total) {
  if (coupon) {
    if (coupon.amount_off) {
      return (coupon.amount_off / 100.0 / 12)

    } else if (coupon.percent_off) {
       return total * (coupon.percent_off / 100.0)
    } else {
      return 0
    }
  } else {
    return 0
  }
}

export function calculateDiscountFromStripeCoupon(coupon, total) {
  if (coupon) {
    if (coupon.amount_off) {
      return (coupon.amount_off / 100.0)

    } else if (coupon.percent_off) {
       return total * (coupon.percent_off / 100.0)
    } else {
      return 0
    }
  } else {
    return 0
  }
}

// https://egghead.io/lessons/javascript-redux-persisting-the-state-to-the-local-storage
export const loadLocalState = (key) => {
  try {
    const serializedState = localStorage.getItem(key)
    if (serializedState === null) {
      return undefined
    }
    return JSON.parse(serializedState)

  } catch (e) {
    return undefined
  }
}

export const saveLocalState = (key, state) => {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem(key, serializedState)
  } catch (e) {
    // err
  }
}



// WEBPACK FOOTER //
// ./src/utils/AppHelper.js